/**
 * Login 的状态管理
 */
import { GET, URLS, POST, PUT, CLEAR_VALUE, REMOVE_VALUE } from '../../utils'
import { types as ToastTypes } from './toast'

export const types = {
  LOAD_LOGIN_STATUS: 'LOGIN/LOAD_LOGIN_STATUS',
  LOGIN: 'LOGIN/LOGIN',
  LOGOUT: 'LOGIN/LOGOUT',
  LOAD_USERINFO: 'LOGIN/LOAD_USERINFO',
  LOAD_OTHERINFO: 'LOGIN/LOAD_OTHERINFO',
  LOAD_UNREAD_MESSAGE: 'LOGIN/LOAD_UNREAD_MESSAGE',
  LOAD_FOLLOWER_EVENT: 'LOGIN/LOAD_FOLLOWER_EVENT',
  CHANGE_STATUS: 'LOGIN/CHANGE_STATUS',
  FETCH_LOGIN: 'LOGIN/LOGIN',
  FETCH_LOGOUT: 'LOGIN/LOGOUT',
  FETCH_USERINFO: 'LOGIN/FETCH_USERINFO',
  FETCH_OTHERINFO: 'LOGIN/FETCH_OTHERINFO',
  FETCH_UNREAD_MESSAGE: 'LOGIN/FETCH_UNREAD_MESSAGE',
  FETCH_UPDATE_USERINFO: 'LOGIN/FETCH_UPDATE_USERINFO',
  FETCH_HAS_ACCESS: 'LOGIN/FETCH_HAS_ACCESS',
  FETCH_CHANGE_LOGIN_STATUS: '/LOGIN/FETCH_CHANGE_LOGIN_STATUS' // 为了ipad webview setToken 更改登陆状态
}

const state = {
  username: localStorage.getItem('username') || '',
  password: '',
  token: localStorage.getItem('Token'),
  // 登录状态标识，true 代表登录，false 代表未登录
  status: !!localStorage.getItem('Token'),
  userInfo: {
    avatar: '',
    name: ''
  },
  otherInfo: {
    avatar: '',
    name: ''
  },
  message: null
}

const mutations = {
  [types.LOAD_USERINFO] (state, dic) {
    state.username = dic.owner
    state.userInfo = {...state.userInfo, ...dic}
  },
  [types.LOAD_OTHERINFO] (state, dic) {
    state.otherInfo = dic
  },
  [types.LOGIN] (state, dic) {
    if (dic && dic.hasOwnProperty('token')) {
      state.token = dic.token
    }
    if (dic && dic.hasOwnProperty('username')) {
      state.username = dic.username
    }
  },
  [types.LOGOUT] (state) {
    (state.token = null), (state.username = '')
  },
  [types.LOAD_UNREAD_MESSAGE] (state, dic) {
    state.message = dic
  },
  // 关注用户，刷新相关数据事件【个人主页】
  [types.LOAD_FOLLOWER_EVENT] (state, param) {
    let followers = param.followers
    if(followers.includes(state.otherInfo.user)){
      state.message['is_follow'] = !state.message.is_follow
    }
  },
  [types.CHANGE_STATUS] (state, param){
    if (param && param.hasOwnProperty('status')) {
      state.status = true
    }
  }
}

const actions = {
  [types.FETCH_CHANGE_LOGIN_STATUS] ({commit, state}, param) {
    if (param){
      localStorage.setItem('Token', param)
      commit(types.CHANGE_STATUS, {status: true})
      commit(types.LOGIN, {token: param})
      return Promise.resolve('true')
    }else{
      return Promise.reject('false')
    }
  },
  /**
   * 判断是否登录，没登录统一弹框提示去登录
   */
  [types.LOAD_LOGIN_STATUS] ({commit, state}, param){
    if(!state.status){
      if(param !== 'no_toast'){
        commit(ToastTypes.SHOW, { message: '你还不是橙旭园用户，请去登录' })
      }
      return Promise.reject("login status: false")
    }else{
      return Promise.resolve("login status: true")
    }
  },

  /**
   * 登录请求
   */
  [types.FETCH_LOGIN] ({ dispatch, commit, state, rootState, rootGetter }) {
    var dic = load_login_data()
    commit(types.LOGIN, dic)
    dispatch(types.FETCH_USERINFO)
  },

  /**
   * 退出登录
   */
  [types.FETCH_LOGOUT]({dispatch, commit}){
    // POST(URLS.logout).then(response => {
      // 清空缓存
      CLEAR_VALUE();
      let newUrl = location.href
      let path
      if (location.host.indexOf('develop.cxy61.com') > -1) {
        origin = 'http://develop.cxy61.com:8004'
      }
      newUrl = encodeURIComponent(newUrl)
      if (location.search) {
        path = `/index/Login?ret=${newUrl}&from=community`
      } else {
        path = `/index/Login?ret=${newUrl}?from=community`
      }
      path = `/index/Login?ret=${newUrl}`
      // console.log(path)
      location.href = path
    // })
  },


  /**
   * 获取当前用户的信息
   */
  [types.FETCH_USERINFO] ({ dispatch, commit, state, rootState, rootGetter }) {
    // var dic = load_userInfo_data();
    return new Promise((resolve,reject) =>{
      GET(URLS.whoami).then(response => {
        localStorage.setItem('username', response.owner)
        localStorage.setItem('ownerInfo', JSON.stringify(response))
        commit(types.LOAD_USERINFO, response)
        resolve(response)
      }).catch(err=>{
        reject(err)
      })
    })
  },

  /**
   * 获取他人信息
   * @param {Number} userid
   */
  [types.FETCH_OTHERINFO] ({ commit }, userid) {
    GET(URLS.userinfo(userid)).then(response => {
      commit(types.LOAD_OTHERINFO, response)
    })
  },

  /**
   * 获取用户未读消息，帖子数等
   * @param {Number} userid
   */
  [types.FETCH_UNREAD_MESSAGE] ({ commit }, userid) {
    GET(URLS.my_unread_message(userid)).then(response => {
      commit(types.LOAD_UNREAD_MESSAGE, response)
    })
  },

  /**
   * 修改用户信息
   * @param {Object} {"data":{}}
   */
  [types.FETCH_UPDATE_USERINFO] ({ commit }, param) {
    let data = param.data
    PUT(URLS.whoami, data).then(response => {
      commit(types.LOAD_USERINFO, response)
    })
  },

  /**
   * 获取用户是否可进入社区
   * @param {Object} {"data":{}}
   */
  [types.FETCH_HAS_ACCESS] ({ commit }) {
    return new Promise((resolve,reject) =>{
      GET(URLS.has_access_user_schedule).then(response => {
        if(response.has_access){
          resolve("has access status: true")
        }else{
          reject("has access status: false")
        }
      })
    })
   
  }
}
const getters = {}

export default {
  state,
  mutations,
  actions,
  getters
}

const load_userInfo_data = () => {
  var dic = {
    pk: 29521,
    owner: '17690804115',
    name: '橙子老师',
    avatar:
      'https://wx.qlogo.cn/mmopen/vi_32/DYAIOgq83er0bnG26uMoLpM7YRyjvrzZtNtYFYGz6VOWNR75QI6G1AUhesxj5yrllgTQBEcpC3ZxUC2yibnf2HA/132',
    diamond: 14916,
    red_diamond: 926000,
    scholarship: 0,
    orange_gold: 0
  }
  return dic
}
const load_login_data = () => {
  var dic = {
    token: 'fd87672ebfdd91c2099e52765f8332fe16fcbeea',
    username: '15201052252'
  }
  return dic
}
